import { useEffect, useState } from 'react';
import { useNotifications } from 'context/NotificationContext';
import { fetchNotificationsCount } from 'services/notifications';
import fetchSessionToken from 'services/fetchSessionToken';

export default function useFetchNotificationCount() : void {
  const { setHasNotifications } = useNotifications();
  const [retries, setRetries] = useState(0);
  const [count, setCount] = useState(0);

  const fetch = async () : Promise<void> => {
    try {
      const data = await fetchNotificationsCount();
      setHasNotifications(data.count > 0);
      setRetries(0);
    } catch {
      await fetchSessionToken();
      setRetries((prev) => prev + 1);
      setHasNotifications(false);
    } finally {
      setCount((prev) => prev + 1);
    }
  };

  useEffect(() => {
    if(retries > 3)
      return;

    if(retries > 0) {
      fetch();
      return;
    }

    const interval = setInterval(() => fetch(), 1000 * 60);

    return () => clearInterval(interval);
  }, [count]);

  useEffect(() => {
    fetch();
  }, []);
}